var productSliders = [];
[...document.querySelectorAll('.product-slider')].forEach((el, i) => {
  var handle = `#${el.dataset.id}`;

  productSliders[i] = new Swiper(el, {
    slidesPerView: 2,
    loop: true,
    spaceBetween: 20,
    watchOverflow:  true,
    watchSlidesVisibility: true,
    allowTouchMove: true,
    speed: 350,
    navigation: {
      prevEl: handle + '-arrow-left',
      nextEl: handle + '-arrow-right'
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        allowTouchMove: false,
      },
      1024: {
        slidesPerView: 4,
        allowTouchMove: false,
      }
    }
  });
});